import { useNavigate } from "react-router-dom";
import feedbackStore from "../../stores/FeedbackStore";
import { FeedbackSeverity } from "../../stores/FeedbackStore/types";
import notificationStore from "../../stores/NotificationStore";
import useTranslation from "../useTranslation";
import { Button } from "@mui/material";

export interface PushNotificationData {
  message: string;
  title: string;
  count: string;
  sound: string;
  additionalData: any;
}

const usePushNotification = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const initializePushNotifications = () => {
    const push = PushNotification.init({
      android: {
        senderID: process.env.REACT_APP_FCM_SENDER_ID,
        icon: "icon", // Reference to res/drawable/icon.png
      },
      ios: {
        alert: "true",
        badge: "true",
        sound: "true",
      },
    });

    push.on(
      "registration",
      ({ registrationId }: { registrationId: string }) => {
        notificationStore
          .registerDevice(
            window.device || {
              uuid: `${window.cordova?.callbackId}`,
              platform: cordova.platformId,
            },
            registrationId
          )
          .then(() => console.info("Device registered: ", window.device?.uuid));
      }
    );

    push.on("notification", (data: PushNotificationData) => {
      if (!data.additionalData.foreground || data.additionalData.coldstart) {
        navigate(data.additionalData.url || "/notifications");
      } else if (data.message) {
        feedbackStore.setShowFeedback(true, {
          message: t(data.message),
          severity: FeedbackSeverity.INFO,
          action: (
            <Button color="inherit" onClick={() => navigate("/notifications")}>
              {t("notifications")}
            </Button>
          ),
        });
      }
    });

    push.on("error", (e: any) => {
      console.error("Push error: ", e);
    });
  };

  return { initializePushNotifications };
};

export default usePushNotification;
